import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-32464e8c"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "home-learn-cards",
  "aria-labelledby": "mobile-learn-title"
};
const _hoisted_2 = {
  class: "learn-heading"
};
const _hoisted_3 = {
  id: "mobile-learn-title"
};
const _hoisted_4 = {
  class: "view-all-articles"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true"
}, "→", -1));

const _hoisted_6 = {
  class: "learn-grid"
};
const _hoisted_7 = {
  class: "article-copy"
};
const _hoisted_8 = {
  class: "article-badge"
};
const _hoisted_9 = {
  class: "article-art",
  "aria-hidden": "true"
};
const _hoisted_10 = ["src"];
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import web3Image from '@/assets/home1/article-web3.png';
import securityImage from '@/assets/home1/article-security.png';
import earnImage from '@/assets/home1/article-earn.png';
import chainImage from '@/assets/home1/article-chain.png';
import { getHomePageCopy } from '@/util/homePageCopy';
export default {
  __name: 'HomeLearnCards',

  setup(__props) {
    const {
      locale
    } = useI18n();
    const copy = computed(() => getHomePageCopy(locale.value).learn);
    const articles = computed(() => [{
      id: 'web3',
      ...copy.value.articles.web3,
      image: web3Image
    }, {
      id: 'stake',
      ...copy.value.articles.stake,
      image: earnImage
    }, {
      id: 'security',
      ...copy.value.articles.security,
      image: securityImage
    }, {
      id: 'chain',
      ...copy.value.articles.chain,
      image: chainImage
    }]);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("header", _hoisted_2, [_createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(copy).title), 1), _createElementVNode("span", _hoisted_4, [_createTextVNode(_toDisplayString(_unref(copy).viewAll) + " ", 1), _hoisted_5])]), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(articles), article => {
        return _openBlock(), _createElementBlock("article", {
          key: article.id,
          class: _normalizeClass(["learn-card", `learn-card--${article.id}`])
        }, [_createElementVNode("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, _toDisplayString(article.category), 1), _createElementVNode("h3", null, _toDisplayString(article.title), 1), _createElementVNode("p", null, _toDisplayString(article.description), 1)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("img", {
          src: article.image,
          alt: ""
        }, null, 8, _hoisted_10)])], 2);
      }), 128))])]);
    };
  }

};